import { relatedEntityTypes } from "@dune/vars";

export type RelatedEntityType = (typeof relatedEntityTypes)[number];

export const RelatedEntityType = {
	BROKER: "BROKER",
	CONSTRUCTION_SITE: "CONSTRUCTION_SITE", 
	PROPOSITION: "PROPOSITION",
	GFA: "GFA",
} as const;

export interface SuccessResponse {
  success: boolean;
}
